import $http from "./http";

// 获取单位信息
export function getUnitInfo(){
    return $http({
        url: `/xmt/unit/Info`,
        method:'post',
        // params: params
      });
}

// 修改单位信息
export function editUnitInfo(data){
    return $http({
        url:`/xmt/unit/update`,
        method:'post',
        data:data
    })
}
// 获取审批信息
export function selectApplyInforma(data){
    return $http({
        url:`/xmt/information/selectApplyInforma`,
        data:data
    })
}
// 获取主管单位部分信息
export function getContactInfo(data){
    return $http({
        url:`/xmt/unit/contactInfo`,
        data:data
    })
}